import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!smartmenus';
import 'hamburgers/dist/hamburgers.css';
import AOS from 'aos';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';
import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import '../scss/entry.scss';
import CurrentLocation from './Location';
import MenuLocation from './MenuLocation';
import { zipSearch } from './zipSearch';

jQuery(document).ready(function($) {
	
	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});
	
	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.utility-menu > .menu-item').each(function(i) {
			$(this).toggleClass('menu-item-hidden');
		})
	});

	// Tabbed Menu Swiper
	const tabbedMenuSwiper = new Swiper(".tabbed-menu__tabs--wrapper", {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
		navigation: {
			nextEl: ".tabbed-menu__tabs--navigation-next-button",
			prevEl: ".tabbed-menu__tabs--navigation-prev-button"
		},
		breakpoints: {
			560: {
				slidesPerView: 2
			},
			768: {
				slidesPerView: 3
			},
			1139: {
				slidesPerView: 4
			}
		}
	})

	// Reviews Swiper
	const reviewsSwiper = new Swiper(".reviews__reviews--wrapper", {
		modules: [Autoplay],
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 5000
		},
		breakpoints: {
			450: {
				slidesPerView: 2
			},
			991: {
				slidesPerView: 3
			}
		}
	})

	// Tabbed Menu tabs
	const allTabs = Array.from(document.querySelectorAll('.tabbed-menu__tab'));

	if (allTabs.length > 0) {
		const tabsContainer = document.querySelector(".tabbed-menu__container")
		allTabs.forEach(tab => {
			tab.addEventListener('click', (e) => {
				if (tab.classList.contains('active-tab')) {
					return;
				} else {
					const oldActiveTab = tabsContainer.querySelector('.active-tab');
					const oldActiveName = oldActiveTab.dataset.tabName;
					const oldActiveContent = tabsContainer.querySelector(`[data-tab-container='${oldActiveName}']`);
					oldActiveTab.classList.remove('active-tab');
					oldActiveContent.classList.remove('active-content');
					const newActiveName = tab.dataset.tabName;
					const newActiveContent = tabsContainer.querySelector(`[data-tab-container='${newActiveName}']`);
					tab.classList.add('active-tab');
					newActiveContent.classList.add('active-content');
				}

			})
		})
	}

	// simple accordions
	$(".simple-accordion-toggle").on("click", function (e) {
		$(this).toggleClass('accordion-active');
		$(this).siblings(".simple-accordion-content").slideToggle("fast");
	})

	// text accordions
	$(".text-accordion-toggle").on("click", function(e) {
		$(this).toggleClass("active-accordion");
		$(this).siblings(".text-accordion-content").slideToggle("fast");
	})

	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="popover"]')[0]) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
			// dismiss the popover on click
			var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
				trigger: 'focus'
			});
		}
	});

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="tooltip"]')[0]) {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl)
			});
		}
	});

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
			}, false);
		});
	}

	// acf accordions
	$('.acf-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.icon').children('.plus-minus').toggleClass('plusser minus');
	});

	// accordions
	$('.accordion-toggle').on('click', function() {
		$(this).next('.accordion-toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
		$(this).toggleClass('active');
	});

	// simple accordions
	$('.simple-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
	});

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	$(function() {
		$('.sm').smartmenus({
			subMenusSubOffsetX: 0,
			subMenusSubOffsetY: -1
		});
	});

	// primary navigation toggle
	$('.nav-toggle').on('click', function() {
		$('.primary-nav-wrap').slideToggle('fast');
	});

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// header scroll effects
	(function () {
		var previousScroll = 0;
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			var currentScroll = $(this).scrollTop();
			if (currentScroll > previousScroll) {
				$('#masthead').addClass('scrolling-down');
				$('#masthead').removeClass('scrolling-up');
			} else {
				$('#masthead').addClass('scrolling-up');
				
				$('#masthead').removeClass('scrolling-down');
			}
			if (scrollTop == 0) {
				$('#masthead').removeClass('scrolling-up');
			}
			previousScroll = currentScroll;
		});
	}());

	// fancybox
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});

	// animate on scroll init
	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				console.log('hit')
				prev = now;
				return func(...args);
			}
		}
	}
	AOS.init({ once: true, duration: 700 });
	$(window).on("scroll", throttle( function() { AOS.refresh() }, 500));

	// Navbar location support
	const locationContainer = document.querySelector(".utility-nav-location-container");

	if (locationContainer) {
		const currentLocation = new CurrentLocation(locationContainer);
	}

	// Menu location support
	const menuLocationContainer = document.querySelector(".menu-block__location--select");

	if (menuLocationContainer) {
		const menuLocation = new MenuLocation(menuLocationContainer);
	}

	// Locations location support
	// const allLocationButtons = Array.from(document.querySelectorAll('.menu-locations__location--button'));

	// if (allLocationButtons.length > 0) {
	// 	allLocationButtons.forEach(btn => {
	// 		btn.addEventListener("click", (e) => {
	// 			e.preventDefault();
	// 			const thisButton = e.target.closest(".menu-locations__location--button");

	// 			if (thisButton) {
	// 				const locationId = thisButton.dataset.locationId;
	// 				const locationName = thisButton.dataset.locationName;
	// 				const menuUrl = thisButton.dataset.menuUrl;
	// 				document.cookie = `locationId=${locationId}; path=/;`;
	// 				document.cookie = `locationName=${locationName}; path=/;`;
	// 				window.location.href = menuUrl;
	// 			}
	// 		})
	// 	})
	// }

	// Single Location View Menu
	const singleLocationMenuButton = document.querySelector(".single-location-info-menu");

	if (singleLocationMenuButton) {
		singleLocationMenuButton.addEventListener("click", (e) => {
			e.preventDefault();
			const locationId = singleLocationMenuButton.dataset.locationId;
			const locationName = singleLocationMenuButton.dataset.locationName;
			const menuUrl = singleLocationMenuButton.dataset.menuUrl;
			document.cookie = `locationId=${locationId}; path=/;`;
			document.cookie = `locationName=${locationName}; path=/;`;
			window.location.href = menuUrl;
		})
	}

	// Locationz zip code
	const locationZipForm = document.querySelector(".menu-locations__zip--form");

	if (locationZipForm) {
		zipSearch(locationZipForm);
	}

	// Locations zip clear
	const locationZipField = document.querySelector('.menu-locations__zip');
	const locationZipClear = document.querySelector(".menu-locations__zip--clear");

	if (locationZipField) {
		locationZipField.addEventListener("input", (e) => {
			if (e.target.value !== "") {
				if (!locationZipClear.classList.contains(".field-has-input")) {
					locationZipClear.classList.add("field-has-input");
				}
			} else {
				locationZipClear.classList.remove("field-has-input");
			}
		})

		if (locationZipClear) {
			locationZipClear.addEventListener("click", (e) => {
				locationZipField.value = "";
				locationZipClear.classList.remove("field-has-input");
			})
		}
	}
});